import React, { useEffect, useRef, useState } from "react";

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const stats = [
    {
      value: "5000+",
      label: "Clients Satisfaits",
      description: "Installations réussies",
    },
    {
      value: "40%",
      label: "Gains de Capacité",
      description: "En moyenne avec nos solutions",
    },
    {
      value: "5M€",
      label: "Économies Générées",
      description: "Pour nos clients",
    },
    {
      value: "50+",
      label: "Déploiements",
      description: "À travers la France",
    },
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-black text-white relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-emerald-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Des résultats qui parlent d'eux-mêmes
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Surmonter les défis d'aujourd'hui et alimenter les progrès de demain
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`text-center transform transition-all duration-700 delay-${index * 100} ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
            >
              <div className="mb-4">
                <span className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-blue-400 to-emerald-400 text-transparent bg-clip-text">
                  {stat.value}
                </span>
              </div>
              <h3 className="text-xl font-semibold mb-2">{stat.label}</h3>
              <p className="text-gray-400 text-sm">{stat.description}</p>
            </div>
          ))}
        </div>

        {/* Scrolling Text */}
        <div className="mt-20 overflow-hidden">
          <div className="whitespace-nowrap animate-scroll">
            <span className="text-6xl md:text-8xl font-bold text-gray-800 inline-block">
              Surmonter les défis d'aujourd'hui et alimenter les progrès de demain.&nbsp;
            </span>
            <span className="text-6xl md:text-8xl font-bold text-gray-800 inline-block">
              Surmonter les défis d'aujourd'hui et alimenter les progrès de demain.&nbsp;
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;